import React from "react";
import { Share, StyleSheet, View } from 'react-native'
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import i18n from "utils/i18n";
import ThemedBlock from 'components/atoms/ThemedBlock'
import Text from "theme/Text";
import Button from 'theme/Button'
import HelperPlatform from 'utils/helper-platform'
import { colorList } from 'utils/colors'
import HelperAlerts from 'utils/HelperAlerts'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import { TESTID } from '_shared/config/testID'
import { ThemedValues } from 'styles/themed'
import VStack from 'components/atoms/stack/VStack'

const HomeMoreAboutScene = () => {

	const onShare = async () => {
		try {

			let content = null;

			if(  HelperPlatform.isIOS() ){
				content = {
					url: 'https://myofficedays.com/'
				};
			}else{
				content = {
					message: 'https://myofficedays.com/'
				}
			}

			const result = await Share.share(content );
			if (result.action === Share.sharedAction) {
				if (result.activityType) {
					// shared with activity type of result.activityType
				} else {
					// shared
				}
			} else if (result.action === Share.dismissedAction) {
				// dismissed
			}
		} catch (error) {
			HelperAlerts.alert( '', error.message );
		}
	};

	const onOpen = () => {
		openUrl( 'https://myofficedays.com/' );
	}

	return (
		<ThemedSafeAreaComponentTop
			top={false}>

			<ThemedLayout
				topNavigation={ true }
				showBackButton={ true }
				footerBar={ false }
				title={ i18n.t( 'titles.more_about_my_office_days' ) }
				testID={ TESTID.HOME.MORE.SCREENS.ABOUT }>
				
				<VStack
					space={ ThemedValues.stackSpace }>
					
					<ThemedBlock shadow mediumPadding>
						<Text style={ styles.textMain}>
							{i18n.t( 'pages.more.about.block_1')}
						</Text>
					</ThemedBlock>
	
					<Choose>
						<When condition={ HelperPlatform.isNotWeb() }>
							<Button
								onPress={ onShare }
								style={ styles.shareButton }
								icon={(
									<Icon
										icon={ IconSystemConstants.FAVOURITE }
										color={colorList.WHITE.primary}
										style={ [ styles.icon ] }
										checked={ true }
									/>
								)}>
	
								{ i18n.t( 'pages.more.about.share') }
							</Button>
						</When>
						<Otherwise>
							<Button
								onPress={ onOpen }
								style={ styles.shareButton }
								icon={(
									<Icon
										icon={ IconSystemConstants.FAVOURITE }
										color={colorList.WHITE.primary}
										style={ [ styles.icon ] }
										checked={ true }
									/>
								)}>
	
								{i18n.t( 'pages.more.about.view')}
							</Button>
						</Otherwise>
					</Choose>
	
					<ThemedBlock shadow mediumPadding>
						<View style={ styles.textContainer}>
							<Text style={ styles.textAbout}>{i18n.t( 'pages.more.about.block_2')}</Text>
						</View>
						<View style={ styles.textContainer}>
							<Text style={ styles.textAbout}>{i18n.t( 'pages.more.about.block_3')}</Text>
						</View>
					</ThemedBlock>
	
					<ThemedBlock shadow mediumPadding>
						<Text style={ styles.textAddress}>On-d-mand international BV</Text>
						<Text style={ styles.textAddress}>Amsterdam Science Park 400</Text>
						<Text style={ styles.textAddress}>1098 XH Amsterdam</Text>
						<Text style={ styles.textAddress}>{ i18n.t( 'ui.country_netherlands' ) }</Text>
					</ThemedBlock>
				</VStack>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	);
}

const styles = StyleSheet.create({
	shareButton: {
		//margin: 16,
		//marginBottom: 48
	},
	icon: {
		color: colorList.WHITE.primary,
		marginRight: 10
	},

	textContainer: {
		marginBottom: 16,
	},

	textMain: {
	},

	textAbout: {
	},

	textAddress: {
		textAlign: 'center'
	}
});

export default HomeMoreAboutScene;
